import React, {useState} from 'react';

import {hooks} from '../hooks';
import {Routes} from '../routes';
import {svg} from '../assets/svg';
import {ActivitiesType} from '../types';
import {components} from '../components';
import {actions} from '../store/actions';

export const DetailActivities: React.FC = () => {
  const navigate = hooks.useNavigate();
  const dispatch = hooks.useDispatch();
  const location = hooks.useLocation();

  const activity: ActivitiesType = location.state.activity;

  const [opacity, setOpacity] = useState<number>(0);

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        showGoBack={true}
        showBasket={true}
        title='Activity'
      />
    );
  };

  const renderImage = (): JSX.Element => {
    return (
      <section style={{position: 'relative', marginBottom: 30}}>
        <img
          src={activity.banner}
          alt={activity.title}
          style={{
            width: '100%',
            height: 'auto'
          }}
        />
      </section>
    );
  };

  const renderDetails = (): JSX.Element => {
    return (
      <section className='container'>
        <div
          className='row-center-space-between'
        >
          <h3
            className='number-of-lines-1'
            style={{textTransform: 'capitalize'}}
          >
            {activity.title}
          </h3>
          <span className='t10'>{activity.date}</span>
        </div>
        <p className='t12'>{activity.location}</p>
        <br />
        <div className="row-center-space-between container" style={{marginBottom: 12, borderTop: '1px solid var(--border-color)', borderBottom: '1px solid var(--border-color)', paddingTop: 10, paddingBottom: 10}}>
          <div>
            <h5>Tanggal :</h5>
            <span className='t10'>{activity.date}</span>
          </div>
          <div>
            <h5>Waktu :</h5>
            <span className='t10'>{activity.time}</span>
          </div>
          <div>
            <h5>Biaya :</h5>
            <span className='t10'>{activity.expense}</span>
          </div>
        </div>
        <div style={{paddingTop: 10}}>
          {activity.long_description.map((para, idx) => (
            <p className='t12' style={{marginBottom: 12}} key={idx}>{para}</p>
          ))}
        </div>
      </section>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <main className='scrollable' style={{paddingTop: 10, paddingBottom: 20}}>
        {renderImage()}
        {renderDetails()}
      </main>
    );
  };

  const renderFooter = (): JSX.Element => {
    return <components.Footer />;
  };

  return (
    <div
      id='screen'
      style={{opacity}}
    >
      {renderHeader()}
      {renderContent()}
      {renderFooter()}
    </div>
  );
};
